import { render, staticRenderFns } from "./ModalResolvedIssue.vue?vue&type=template&id=58947602&scoped=true&"
import script from "./ModalResolvedIssue.vue?vue&type=script&lang=js&"
export * from "./ModalResolvedIssue.vue?vue&type=script&lang=js&"
import style0 from "./ModalResolvedIssue.vue?vue&type=style&index=0&id=58947602&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58947602",
  null
  
)

export default component.exports